import { Modal } from 'antd';
import { useUpdate } from '@refinedev/core';

type Props = {
  cancelId?: string;
  onClose: () => void;
};

export const CancelDialog = ({ cancelId, onClose }: Props) => {
  const { mutate } = useUpdate();

  return (
    <Modal
      open={!!cancelId}
      title="キャンセル"
      onCancel={onClose}
      onOk={() => {
        if (!cancelId) return;

        mutate(
          {
            resource: 'experienceReservations',
            id: cancelId,
            values: {
              status: 'canceled',
            },
            meta: {
              fields: [
                {
                  experienceReservation: ['id', 'status'],
                },
              ],
            },
          },
          {
            onSuccess: onClose,
          },
        );
      }}
    >
      <p>本当にキャンセルしますか？</p>
    </Modal>
  );
};
